import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810] py-12">
      <div className="max-w-4xl mx-auto px-4 space-y-8 bg-white p-8 md:p-12 rounded-2xl border border-[#E8DFD8] shadow-sm">
        <div className="text-center space-y-2 border-b border-[#E8DFD8] pb-6">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#C49A45]">Legal & Trust</span>
          <h1 className="font-heading text-3xl font-bold text-[#2B1810]">Privacy Policy</h1>
          <p className="text-xs text-[#8A796C]">Last updated: August 17, 2026</p>
        </div>

        <div className="space-y-6 text-xs leading-relaxed text-[#2B1810]">
          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">1. Introduction</h2>
            <p className="text-[#8A796C]">
              Welcome to Chandana Aura. We respect your privacy and are committed to protecting your personal data. This privacy policy informs you how we look after your personal data when you visit our website, purchase authentic sandalwood products, or interact with our services.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">2. Data We Collect</h2>
            <p className="text-[#8A796C]">
              We collect information necessary to fulfill your orders and provide a seamless shopping experience:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-[#8A796C]">
              <li><strong>Contact Information:</strong> Name, delivery address, phone number, email address.</li>
              <li><strong>Order Data:</strong> Purchased products, transaction IDs, payment method selection.</li>
              <li><strong>Device & Geolocation:</strong> Device GPS coordinates (only when auto-filling delivery address).</li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">3. How We Use Your Data</h2>
            <p className="text-[#8A796C]">
              Your data is strictly used for order processing, dispatching shipments via logistics partners, providing customer support, issuing authenticity certificates, and notifying you about order status updates.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">4. Payment Security</h2>
            <p className="text-[#8A796C]">
              We do not store full card numbers or banking passwords on our servers. Online card, UPI, wallet, and net banking payments are securely processed by Razorpay.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">5. Contact Us</h2>
            <p className="text-[#8A796C]">
              If you have any questions regarding this Privacy Policy, please email us at <strong>privacy@chandanaaura.com</strong> or call <strong>+91 98765 43210</strong>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
